import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import Parameters from 'shared/parameters';
import {Link, useHistory} from 'react-router-dom';
import Sider from 'antd/lib/layout/Sider';
import iconDashboard from '../../img/icon-dashboard.png';
import iconDashboardActive from '../../img/icon-dashboard-active.png';
import iconMyCourse from '../../img/icon-my-course.png';
import iconMyCourseActive from '../../img/icon-my-course-active.png';
import iconMeeting from '../../img/icon-meeting.png';
import iconMeetingActive from '../../img/icon-meeting-active.png';
import iconReview from '../../img/icon-review.png';
import iconReviewActive from '../../img/icon-review-active.png';
import iconMyBadges from '../../img/icon-my-badges.png';
import iconMyBadgesActive from '../../img/icon-my-badges-active.png';
import iconInsight from '../../img/icon-insight.png';
import iconInsightActive from '../../img/icon-insight-active.png';
interface Props{
    menuSelect : number,
}
export default function FrontendSidebar(props: Props) {
    const { t } = useTranslation();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
  return (
    <div>
        {Parameters.Mode === 'CLIENT' && <Sider className={'sider-wrapper'} width={230} theme={'dark'} style={{height: '100%'}}>
            <div className='menu-wrapper'>
                <nav className="navbar">
                    <ul className="navbar-nav w-100">
                        <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 1 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" } 
                            onClick={() =>{
                                history.push(`/my/profile`);
                            }}>
                                <img src={props.menuSelect === 1 ? iconDashboardActive : iconDashboard} className={'mr-3'} style={{width: "18px"}} />
                                {/* <span>{t('Profile')}</span> */}
                                {t('genDict.profile')}
                            </a>
                        </li>
                        <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 2 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" } 
                            onClick={() =>{
                                history.push(`/my/management/my/courses`);
                            }}>
                            <img src={props.menuSelect === 2 ? iconMyCourseActive : iconMyCourse} className={'mr-3'} style={{width: "18px"}} />
                            {/* <span>{t('My Course')}</span> */}
                            {t('genDict.MyCourse')}
                            </a>
                        </li>
                        {/* <li className="nav-item pt-2 pb-2">
                            <a type='button'
                            className={props.menuSelect === 3 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" } 
                            onClick={() =>{
                                history.push(`/my/management/upcomming-meetings`);
                            }}>
                            <img src={props.menuSelect === 3 ? iconMeetingActive : iconMeeting} className={'mr-3'} style={{width: "18px"}} />
                            <span>{t('Meetings')}</span>
                            </a>
                        </li> */}
                        <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 4 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" } 
                            onClick={() =>{
                                history.push(`/my/management/reviews`);
                            }}>
                            <img src={props.menuSelect === 4 ? iconReviewActive : iconReview} className={'mr-3'} style={{width: "18px"}} />
                            {/* <span>{t('Reviews')}</span> */}
                            <span>{t('genDict.Reviews')}</span>
                            </a>
                        </li>
                        {/* {user?.role?.slug === 'STUDENT' ?<li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 5 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" }  
                            onClick={() =>{
                                history.push(`/my/management/orders`);
                            }}>
                            <img src={props.menuSelect === 5 ? iconInsightActive : iconInsight} className={'mr-3'} style={{width: "18px"}} />
                            <span>{ t('Subscribe Courses')}</span>
                            </a>
                        </li>
                        :<></>
                        } */}
                        {user?.role?.slug !== 'INSTRUCTOR' && <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 6 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" }  
                            onClick={() =>{
                                history.push(`/my/management/badges`);
                            }}>
                            <img src={props.menuSelect === 6 ? iconMyBadgesActive : iconMyBadges} className={'mr-3'} style={{width: "18px"}} />
                            {/* <span>{t('My Badges')}</span> */}
                            {t('genDict.MyBadges')}
                            </a>
                        </li>
                        }
                        {user?.role?.slug === 'INSTRUCTOR' && <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 7 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" }  
                            onClick={() =>{
                                history.push(`/my/management/courses-report`);
                            }}>
                            <img src={props.menuSelect === 7 ? iconMyBadgesActive : iconMyBadges} className={'mr-3'} style={{width: "18px"}} />
                            <span>{t('Course Report')}</span>
                            </a>
                        </li>}
                        {user?.role?.slug === 'INSTRUCTOR' && <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 8 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" }  
                            onClick={() =>{
                                history.push(`/my/management/course-student`);
                            }}>
                            <img src={props.menuSelect === 8 ? iconMyBadgesActive : iconMyBadges} className={'mr-3'} style={{width: "18px"}} />
                            <span>{t('Subscribers')}</span>
                            </a>
                        </li>}
                        {user?.role?.slug !== 'INSTRUCTOR' && <li className="nav-item pt-2 pb-2">
                            <a type='button' 
                            className={props.menuSelect === 9 ? "d-flex align-items-center text-white p-2 activeProfileMenu" : "d-flex align-items-center text-white p-2" }  
                            onClick={() =>{
                                history.push(`/my/management/training-schedule`);
                            }}>
                            <img src={props.menuSelect === 9 ? iconMyBadgesActive : iconMyBadges} className={'mr-3'} style={{width: "18px"}} />
                            <span>{t('genDict.trainingSchedule')}</span>
                            </a>
                        </li>
                        }
                    </ul>
                </nav>
            </div>
        </Sider>}
    </div>
  )
}
